import React from "react";
import AgentSidebar from "../Commun/AgentSidebar";
import { AgentHeader } from "../Commun/AgentHeader";
import { AgentRoomInventoryCal } from "./AgentRoomInventoryCal";

export const AgentDashboard = () => {
  return (
    <>
      <div className="wrapper">
        <AgentSidebar />
        <div className="main-panel">
          <AgentHeader />
          <div className="container">
            <div className="page-inner">
              <div className="page-header">
                <div className="row">
                  <div className="col-sm-12">
                    <h3 className="page-title">Dashboard</h3>
                  </div>
                </div>
              </div>
              <AgentRoomInventoryCal />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
